/** Subtext under Store 2.0 price lines (search cards, provider care cards). */
export const STORE_DISPLAY_PRICE_SUBTEXT = 'with or without insurance'

/** Price line fallback when a SKU has no price estimate (home medication shelves, provider care cards). */
export const STORE_DISPLAY_PRICE_UNAVAILABLE_LABEL = 'Price after visit'

function formatDollarAmount(amountInDollars: number): string {
    return Number.isInteger(amountInDollars) ? String(amountInDollars) : amountInDollars.toFixed(2)
}

/** Formats a dollar amount as "$25" or "$25.50". */
export function formatStoreDisplayPrice(amountInDollars: number): string {
    return `$${formatDollarAmount(amountInDollars)}`
}

/** Formats cents as "$25" or "$25.50". */
export function formatStoreDisplayPriceFromCents(cents: number): string {
    return formatStoreDisplayPrice(cents / 100)
}

/** Formats a dollar amount as "from $25". */
export function formatStoreDisplayFromPrice(amountInDollars: number): string {
    return `from ${formatStoreDisplayPrice(amountInDollars)}`
}

/** Formats cents as "from $25". */
export function formatStoreDisplayFromPriceFromCents(cents: number): string {
    return formatStoreDisplayFromPrice(cents / 100)
}

/** Card price line always prefixed with "from" (provider detail cards, search results). */
export function formatStoreDisplayCardFromPrice(
    amountInDollars: number | null | undefined,
): string | null {
    if (amountInDollars == null) return null
    return formatStoreDisplayFromPrice(amountInDollars)
}

/** List row price: "$25" for fixed estimates, "from $50" when rate sensitivity is variable. */
export function formatStoreDisplayListPrice(
    amountInDollars: number | null | undefined,
    rateSensitivity?: string | null,
): string | null {
    if (amountInDollars == null) return null

    if (rateSensitivity === 'variable') {
        return formatStoreDisplayFromPrice(amountInDollars)
    }

    return formatStoreDisplayPrice(amountInDollars)
}
